<div class="hero">
  <div class="lonely-title">
    <h1>Tutte le destinazioni</h1>
    <span
      >Scopri tutte le destinazioni di Social Travels e prenota il tuo nuovo
      viaggio</span
    >
  </div>
</div>

@for (d of destinations; track $index) {
  <div class="bg-muted-t mt-6 mb-3">
    <div class="container">
      <h2 class="m-0">{{ d.name }}</h2>
    </div>
  </div>
  <div class="container">
    @if (loading) {
      <div class="backdrop-mini-loader">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>
    } @else {
      <div class="grid mb-10">
        @for (c of d.countries; track c.country.ISO) {
          <div class="col-12 md:col-4">
            @if (c.country && c.country.medias!.length > 0) {
              <a class="card" [routerLink]="url.country(c.country)">
                <div class="gradient"></div>
                <img
                  [src]="c.country.medias![0].media | imagePipe: 'user' : 'lg'"
                />
                <div class="title">
                  <p>{{ c.country.name }}</p>
                </div>
              </a>
            } @else {
              <a class="card" [routerLink]="url.country(c.country)">
                <div class="placeholder">
                  <img src="/assets/media/icons/photos.png" />
                </div>
                <div class="title">
                  <p>{{ c.country.name }}</p>
                </div>
              </a>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (!auth.isLogged() || (auth.isLogged() && !auth.isAnyTourLeader())) {
  <app-leader></app-leader>
}

<app-request></app-request>
